import React from 'react';
import styles from '../styles/ActionButton.module.css';

/**
 * Botón de acción reutilizable
 * @param {Function} onClick - Handler del click
 * @param {ReactNode} children - Contenido del botón (texto)
 * @param {ReactNode} icon - Icono opcional
 * @param {string} subtitle - Texto secundario debajo del botón
 * @param {string} variant - Variante de estilo: 'primary', 'secondary', 'outline'
 * @param {string} className - Clases CSS adicionales
 */
const ActionButton = ({ 
  onClick, 
  children, 
  icon = null, 
  subtitle = null, 
  variant = 'primary',
  className = '',
  ...props 
}) => {
  return (
    <div className={`${styles.actionButtonSection} ${className}`}>
      <button 
        className={`${styles.actionButton} ${styles[variant]}`}
        onClick={onClick}
        {...props}
      >
        {icon && <span className={styles.buttonIcon}>{icon}</span>}
        <span className={styles.buttonText}>{children}</span>
      </button>
      {subtitle && <p className={styles.buttonSubtitle}>{subtitle}</p>}
    </div>
  );
};

export default ActionButton;
